import React from 'react';
import { useLocation } from 'react-router-dom';
import AIBuilderSection from '../components/home/AIBuilderSection';
import SEOHead from '@/components/SEOHead';

export default function AIBuilder() {
  const location = useLocation();
  const templatePrompt = location.state?.templatePrompt || '';
  const editWebsite    = location.state?.editWebsite || null;

  // Prefer the edit website's prompt when refining an existing site
  const initialPrompt = editWebsite?.prompt || templatePrompt;

  return (
    <div>
      <SEOHead
        title="AI Website Builder"
        description="Describe any website and our AI will build it in seconds. Get production-ready HTML, CSS & JavaScript instantly — no coding required."
        ogUrl="https://builderslab.net/AIBuilder"
      />
      <AIBuilderSection initialPrompt={initialPrompt} />
    </div>
  );
}